import React, { useState, useEffect } from "react";
import StepCircle from "../StepCircle";
import {
  Typography,
  TextField,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Stepper,
  Step,
  StepLabel,
  Grid,
  Checkbox,
  FormControlLabel
} from "@mui/material";
import api from "../../api";

const steps = ["Detalles del Mantenimiento", "Asignar Vehículo"];

const AgregarMantenimiento = ({ vehiculo, handleClose, onUpdate }) => {
  const [selectedVehiculo, setSelectedVehiculo] = useState(vehiculo || null);
  const [step, setStep] = useState(vehiculo ? 0 : 0);

  const [mantenimiento, setMantenimiento] = useState({
    descripcion: "",
    monto: "",
    taller: "",
    solicitud: "",
    fecha_requerimiento: "",
    rta_ccoo: "",
    estado_reparacion: "",
    fecha_ingreso: "",
    fecha_egreso: "",
    abonado: false,
    nro_factura: "",
    tramix_nro: "",
    cargado_en_ficha_tec: false,
    vehiculo: "",
  });

  const [vehiculos, setVehiculos] = useState([]);
  const [isStep1Valid, setIsStep1Valid] = useState(false);

  useEffect(() => {
    api
      .get("vehiculos/")
      .then((response) => setVehiculos(response.data))
      .catch(() => alert("Error al cargar vehículos."));
  }, []);

  useEffect(() => {
    if (vehiculo) {
      setSelectedVehiculo(vehiculo);
      setMantenimiento((prev) => ({
        ...prev,
        vehiculo: vehiculo.id,
      }));
    }
  }, [vehiculo]);

  useEffect(() => {
    const { descripcion, monto } = mantenimiento;
    setIsStep1Valid(descripcion && monto);
  }, [mantenimiento]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setMantenimiento({
      ...mantenimiento,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleNext = () => {
    if (vehiculo) {
      handleSubmit(new Event("submit"));
    } else {
      setStep((prev) => prev + 1);
    }
  };

  const handleBack = () => setStep((prev) => prev - 1);

  const handleSubmit = (e) => {
    e.preventDefault();
    api
      .post("mantenimiento/", mantenimiento)
      .then((response) => {
        alert("Mantenimiento agregado correctamente");
        if (onUpdate) {
          onUpdate(response.data); // send the new data to parent
        }
        handleClose();
      })
      .catch((error) => {
        console.error("Error al agregar mantenimiento:", error.response || error);
        alert("Hubo un error al agregar el mantenimiento.");
      });
  };

  return (
    <form onSubmit={handleSubmit} style={{ width: "100%", maxWidth: "700px", margin: "0 auto" }}>
      <Typography variant="h6" style={{ color: "#152d51", fontWeight: "bold" }}>
        Agregar Mantenimiento
      </Typography>

      <Stepper activeStep={step} alternativeLabel>
        {steps.map((label, index) => (
          <Step key={index}>
            <StepLabel StepIconComponent={StepCircle}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      {step === 0 && (
        <Grid container spacing={2} style={{ marginTop: 20 }}>
          <Grid item xs={12}>
            <TextField
              label="Descripción"
              name="descripcion"
              value={mantenimiento.descripcion}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              label="Monto"
              name="monto"
              type="number"
              value={mantenimiento.monto}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Taller / Mecánico"
              name="taller"
              value={mantenimiento.taller}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              label="Solicitud"
              name="solicitud"
              value={mantenimiento.solicitud}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Fecha de Requerimiento"
              name="fecha_requerimiento"
              type="date"
              value={mantenimiento.fecha_requerimiento}
              onChange={handleChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              label="RTA CCOO"
              name="rta_ccoo"
              value={mantenimiento.rta_ccoo}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Estado de Reparación"
              name="estado_reparacion"
              value={mantenimiento.estado_reparacion}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              label="Fecha de Ingreso"
              name="fecha_ingreso"
              type="date"
              value={mantenimiento.fecha_ingreso}
              onChange={handleChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Fecha de Egreso"
              name="fecha_egreso"
              type="date"
              value={mantenimiento.fecha_egreso}
              onChange={handleChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              label="Número de Factura"
              name="nro_factura"
              value={mantenimiento.nro_factura}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Tramix Nro"
              name="tramix_nro"
              value={mantenimiento.tramix_nro}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          <Grid item xs={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={mantenimiento.abonado}
                  onChange={handleChange}
                  name="abonado"
                />
              }
              label="¿Abonado?"
            />
          </Grid>
          <Grid item xs={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={mantenimiento.cargado_en_ficha_tec}
                  onChange={handleChange}
                  name="cargado_en_ficha_tec"
                />
              }
              label="¿Cargado en Ficha Técnica?"
            />
          </Grid>

          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleNext}
              sx={{ background: "#152d51" }}
              disabled={!isStep1Valid}
            >
              {vehiculo ? "Agregar Mantenimiento" : "Siguiente"}
            </Button>
          </Grid>
        </Grid>
      )}

      {step === 1 && !vehiculo && (
        <Grid container spacing={2} style={{ marginTop: 20 }}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel style={{ background: "white" }}>Vehículo</InputLabel>
              <Select name="vehiculo" value={mantenimiento.vehiculo} onChange={handleChange}>
                <MenuItem value="">Seleccionar vehículo</MenuItem>
                {vehiculos.map((v) => (
                  <MenuItem key={v.id} value={v.id}>
                    {v.patente} - {v.marca} {v.modelo}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <Button variant="outlined" fullWidth onClick={handleBack}>
              Atrás
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button type="submit" variant="contained" color="primary" fullWidth sx={{ background: "#152d51" }}>
              Agregar Mantenimiento
            </Button>
          </Grid>
        </Grid>
      )}
    </form>
  );
};

export default AgregarMantenimiento;
